import React from 'react';
import { Paper, Typography } from '@mui/material';
import AlertsInbox from '../AlertsInbox';

export default function AlertsOverviewWidget({
  userData,
  alertsRemote,
  alertDetailId,
  onFocusedAlertChange,
  onCreateTicketFromAlert,
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Notifications
      </Typography>
      <AlertsInbox
        userData={userData}
        showTitle={false}
        alertsRemote={alertsRemote}
        focusedAlertId={alertDetailId}
        onFocusedAlertChange={onFocusedAlertChange}
        onCreateTicketFromAlert={onCreateTicketFromAlert}
      />
    </Paper>
  );
}
